
const style = {
    fontWeight: 700,
    color: "var(--text-color)",
    fontSize: 14,
}

export const DefaultTitle: React.FC<{ title: string, fontSize?: number }> = ({ title, fontSize }) => {
    return (
        <p style={{ ...style, fontSize }}>{title}</p>
    )
}